import * as $rdf from '@rdf-esm/data-model';
export function redirectTarget(response) {
  if (response.redirectUrl != null) {
    return $rdf.namedNode(response.redirectUrl);
  }

  return undefined;
}